import { useEffect, useRef } from 'react';
import { useAuthStore } from 'src/store/auth';
import { authService } from 'src/services/auth';
import { UserResponse } from 'src/services/interfaces/auth';
import { applicationService } from 'src/services/application';
import { useApplicationStore } from 'src/store/application';

export const useAuthInitialization = () => {
  const { user, setUserFromGetMe, logout } = useAuthStore();
  const { setIsMainPlanRejected, fetchActiveSubscriptionPlans, updateTierFromApplicationState } = useApplicationStore();
  const initializedRef = useRef(false);

  useEffect(() => {
    const initializeAuth = async () => {
      const storedToken = localStorage.getItem('token');

      if (storedToken && !user?.username && !initializedRef.current) {
        initializedRef.current = true;
        try {
          const userResponse: UserResponse = await authService.getMe();

          const user = {
            ...userResponse,
            id: userResponse.id,
            username: userResponse.email,
          };

          setUserFromGetMe(user);

          let isMainPlanRejected = false;
          try {
            const applicationState = await applicationService.applicationState()
            if(applicationState.phqRejectedAt){
              isMainPlanRejected = true;
            }
            // Update tier based on applicationState
            updateTierFromApplicationState();
          } catch (error) {
            console.log('Application state not available yet:', error);
          }
          console.log('isMainPlanRejected', isMainPlanRejected);
          setIsMainPlanRejected(isMainPlanRejected);
          // fetchActiveSubscriptionPlans();
        } catch (error) {
          console.error('Failed to initialize auth:', error);
          logout();
        }
      }
    };

    initializeAuth();
  }, [user?.username, initializedRef.current]);
};
